// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZxEkQ","left":"styles_left__3yiBA","desktopActions":"styles_desktopActions__3PVij","title":"styles_title__qZ0fe"};